export default __webpack_public_path__ + "static/microsoft-7667d61cb24808e1b1316977bf836aef.jpg";